import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { SearchPipe } from "./search/search.pipe"; // <---
import { FormatTimePipe } from './format-time.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { LinkifyPipe } from './linkify.pipe';
import { PackageDescriptionPipe } from './package-description.pipe';

@NgModule({
  declarations: [SearchPipe, FormatTimePipe, SafeHtmlPipe, LinkifyPipe, PackageDescriptionPipe], // <---
  imports: [CommonModule],
  exports: [SearchPipe, FormatTimePipe, SafeHtmlPipe, LinkifyPipe, PackageDescriptionPipe] // <---
})

export class MainPipe { }